// postos-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    ", mas não há nenhuma cobrança de implantação neste posto.": ", pero no hay ningún cobro de implementación en esta estación.",
    ". As parcelas seguem o intervalo da forma de pagamento do posto — 30 dias nos boletos da PontuaX.": ". Las cuotas siguen el intervalo de la forma de pago de la estación — 30 días en los boletos de PontuaX.",
    ". Boleto pago antes do início da janela não é devolvido pelo Gestão Click.": ". El boleto pagado antes del inicio de la ventana no es devuelto por Gestão Click.",
    "1x": "1x",
    "2x": "2x",
    "A loja define em qual conta bancária o boleto será emitido. Não há padrão — a escolha é obrigatória.": "La tienda define en qué cuenta bancaria se emitirá el boleto. No hay un valor predeterminado — la elección es obligatoria.",
    "Aberto 24 Horas": "Abierto 24 horas",
    "Aberto 24 horas": "Abierto 24 horas",
    "Acompanhar Abastecimento GNV em tempo real": "Seguir carga de combustible GNV en tiempo real",
    "Acompanhar Abastecimento em tempo real (Outros combustíveis)": "Seguir carga de combustible en tiempo real (Otros combustibles)",
    "Aplicar desconto": "Aplicar descuento",
    "As demais credenciais do BB são configuradas na Rede": "Las demás credenciales del BB se configuran en la Red",
    "Assinatura ativa no Gestão Click": "Suscripción activa en Gestão Click",
    "AutoSystem": "AutoSystem",
    "Boleto e nota fiscal continuam na interface do Gestão Click — a API não expõe link de boleto, e a listagem de NFS-e não aceita filtro por cliente.": "El boleto y la factura fiscal siguen en la interfaz de Gestão Click — la API no expone el link del boleto, y el listado de NFS-e no acepta filtro por cliente.",
    "CNPJ com situação cadastral": "CNPJ con situación de registro",
    "Cadastre o CNPJ do posto na aba Identificação antes de continuar.": "Registre el CNPJ de la estación en la pestaña Identificación antes de continuar.",
    "Cashback e Pontuação": "Cashback y puntuación",
    "Certificado Dotz": "Certificado Dotz",
    "Chave PIX": "Clave PIX",
    "Chave da Quality": "Clave de Quality",
    "Cliente criado no Gestão Click": "Cliente creado en Gestão Click",
    "Cliente no Gestão Click": "Cliente en Gestão Click",
    "Cobrança criada no Gestão Click": "Cobro creado en Gestão Click",
    "CompanyTec": "CompanyTec",
    "Concentradores": "Concentradores",
    "Concetradores": "Concentradores",
    "Conferir dados na Receita": "Verificar datos en la Receita",
    "Conta da Quality": "Cuenta de Quality",
    "Contas a Receber": "Cuentas por cobrar",
    "Coordenadas (": "Coordenadas (",
    "Criar cliente no Gestão Click": "Crear cliente en Gestão Click",
    "Criar no Gestão Click": "Crear en Gestão Click",
    "Data de início da implantação": "Fecha de inicio de la implementación",
    "Data de início do faturamento": "Fecha de inicio de la facturación",
    "Define a conta bancária do boleto": "Define la cuenta bancaria del boleto",
    "Define a conta bancária e a forma de pagamento do boleto": "Define la cuenta bancaria y la forma de pago del boleto",
    "Desative para não aplicar descontos neste nível de preço": "Desactive para no aplicar descuentos en este nivel de precio",
    "Dia de vencimento": "Día de vencimiento",
    "E-mail de cobrança": "E-mail de cobro",
    "E-mail para envio da nota fiscal": "E-mail para envío de la factura fiscal",
    "E-mail para envio do boleto": "E-mail para envío del boleto",
    "EZTec": "EZTec",
    "Editar posto": "Editar estación",
    "Encontrado no Gestão Click": "Encontrado en Gestão Click",
    "Este posto nunca teve cobrança de implantação": "Esta estación nunca tuvo cobro de implementación",
    "Ex: índice 1 = Dinheiro, índice 2 = Crédito": "Ej: índice 1 = Efectivo, índice 2 = Crédito",
    "Faturamento recorrente": "Facturación recurrente",
    "Feriados": "Feriados",
    "Forma": "Forma",
    "Forma de pagamento": "Forma de pago",
    "Gateway de pagamento": "Pasarela de pago",
    "Gerar cashback no abastecimento": "Generar cashback en la carga de combustible",
    "Gerar cobrança": "Generar cobro",
    "Hora de abertura": "Hora de apertura",
    "Hora de fechamento": "Hora de cierre",
    "IDs Numéricos": "IDs numéricos",
    "Id numérico": "Id numérico",
    "Implantação": "Implementación",
    "Incrição Estadual": "Inscripción Estatal",
    "Informe as coordenadas em 4 pontos que formam um retângulo": "Indique las coordenadas en 4 puntos que forman un rectángulo",
    "Inscrição Estadual": "Inscripción Estatal",
    "Início do faturamento": "Inicio de la facturación",
    "Janela consultada:": "Ventana consultada:",
    "Ligar assim mesmo": "Activar de todas formas",
    "Liquidação": "Liquidación",
    "Loja do Gestão Click": "Tienda de Gestão Click",
    "Loja não identificada — o cadastro do cliente não guarda loja no Gestão Click; ela é deduzida das cobranças, e este posto ainda não tem nenhuma.": "Tienda no identificada — el registro del cliente no guarda la tienda en Gestão Click; se deduce a partir de los cobros, y esta estación todavía no tiene ninguno.",
    "Mapa de Pista": "Mapa de playa",
    "Marco inicial para cálculo do tempo de implantação. Deixe vazio para usar a data de criação do posto.": "Hito inicial para el cálculo del tiempo de implementación. Deje vacío para usar la fecha de creación de la estación.",
    "Mensalidade": "Mensualidad",
    "Mostrar mapa": "Mostrar mapa",
    "Mostrar preço durante o abastecimento": "Mostrar precio durante la carga de combustible",
    "Motivo da carência": "Motivo de la carencia",
    "Mínimo para resgate de cashback": "Mínimo para canje de cashback",
    "Nada a preencher — os campos já estão preenchidos": "Nada que completar — los campos ya están completos",
    "Nenhum cliente com esse CNPJ no Gestão Click": "Ningún cliente con ese CNPJ en Gestão Click",
    "Nenhuma cobrança nesse filtro.": "Ningún cobro en este filtro.",
    "Nenhuma coordenada cadastrada": "Ninguna coordenada registrada",
    "Nome Fantasia (Receita)": "Nombre fantasía (Receita)",
    "Nome de exibição": "Nombre de visualización",
    "Nome do ícone da biblioteca MaterialCommunityIcons. Acesse materialdesignicons.com para pesquisar. Ex: credit-card, cash, bank": "Nombre del ícono de la biblioteca MaterialCommunityIcons. Ingrese a materialdesignicons.com para buscar. Ej: credit-card, cash, bank",
    "Normalmente a implantação vem primeiro. Confirma que é mensalidade mesmo?": "Normalmente la implementación viene primero. ¿Confirma que es mensualidad?",
    "Novo Posto": "Nueva estación",
    "Não foi possível casar a cidade com o cadastro do Gestão Click. O cliente será criado sem cidade e ela precisará ser preenchida no ERP.": "No fue posible hacer coincidir la ciudad con el registro de Gestão Click. El cliente será creado sin ciudad y deberá completarse en el ERP.",
    "Níveis de Preço": "Niveles de precio",
    "O Gestão Click divide o total pelo número de parcelas:": "Gestão Click divide el total por el número de cuotas:",
    "O posto aponta para um cadastro que sumiu do ERP. Remova o vínculo e refaça.": "La estación apunta a un registro que desapareció del ERP. Quite el vínculo y vuelva a hacerlo.",
    "Pagamento": "Pago",
    "Parcelas": "Cuotas",
    "Percentual sobre a mensalidade": "Porcentaje sobre la mensualidad",
    "Período de carência": "Período de carencia",
    "Período de carência (mês)": "Período de carencia (mes)",
    "Posto ainda não vinculado": "Estación aún no vinculada",
    "Posto vinculado ao Gestão Click": "Estación vinculada a Gestão Click",
    "Preset por Valor (Encher tanque)": "Preset por valor (llenar tanque)",
    "Procurar pelo CNPJ": "Buscar por el CNPJ",
    "Procure pelo CNPJ antes de criar — cliente duplicado no Gestão Click é trabalhoso de desfazer.": "Busque por el CNPJ antes de crear — un cliente duplicado en Gestão Click es difícil de deshacer.",
    "Qrcode": "QR Code",
    "Razão social, inscrição estadual e endereço vêm da Receita Federal pelo CNPJ — o cadastro do posto não guarda esses campos e o Gestão Click precisa deles para emitir nota.": "La razón social, la inscripción estatal y la dirección vienen de la Receita Federal según el CNPJ — el registro de la estación no guarda esos campos y Gestão Click los necesita para emitir la factura.",
    "Remover vínculo": "Quitar vínculo",
    "Rótulo": "Etiqueta",
    "Rótulos dos níveis de preço": "Etiquetas de los niveles de precio",
    "Senha Sanvitron": "Contraseña Sanvitron",
    "Senha do certificado": "Contraseña del certificado",
    "Sim, é mensalidade": "Sí, es mensualidad",
    "Sincronização": "Sincronización",
    "Sistema": "Sistema",
    "Token Confere Pix": "Token Confere Pix",
    "Token Fixpay": "Token Fixpay",
    "Token RTI": "Token RTI",
    "Token Top Banho (Rede Trevo)": "Token Top Banho (Red Trevo)",
    "Trocar para implantação": "Cambiar a implementación",
    "URL Sanvitron": "URL Sanvitron",
    "Usar integração com Software House": "Usar integración con Software House",
    "Usar níveis de preço": "Usar niveles de precio",
    "Usuário Sanvitron": "Usuario Sanvitron",
    "Valor da instalação": "Valor de la instalación",
    "Valor da mensalidade": "Valor de la mensualidad",
    "Valor e vencimento vêm do cadastro do posto e podem ser ajustados aqui. Conta bancária, forma de pagamento e plano de contas são definidos pela loja: PontuaX emite em Bradesco - PontuaX, PontuaX Tec em Bradesco - PontuaX Tec.": "El valor y el vencimiento vienen del registro de la estación y pueden ajustarse aquí. La cuenta bancaria, la forma de pago y el plan de cuentas son definidos por la tienda: PontuaX emite en Bradesco - PontuaX, PontuaX Tec en Bradesco - PontuaX Tec.",
    "Valor fixo por mês": "Valor fijo por mes",
    "Valor total (R$)": "Valor total (R$)",
    "Vencimento da mensalidade (dia)": "Vencimiento de la mensualidad (día)",
    "Vincular": "Vincular",
    "Você está gerando uma": "Usted está generando una",
    "Vínculo removido": "Vínculo eliminado",
    "com vencimento em": "con vencimiento en",
    "mensalidade": "mensualidad",
    "na Receita.": "en la Receita.",
    "não existe mais no Gestão Click": "ya no existe en Gestão Click",
    "pontos)": "puntos)",
    "x de": "x de",
    "Índice": "Índice",
    "Índice (1, 2, 3...)": "Índice (1, 2, 3...)",
    "Último Ping": "Último Ping",
    "Último Ponto da Sincronização": "Último punto de la sincronización",
    "— CEP": "— CEP",
};

export default catalogo;
